import { asArray, isLive, layoutCurrentDesigns } from '@repo/front-end-utils';
import type { FloorPlannerLayout } from '@repo/frontend-types';

import { readObserverReferences, useObserverStampStore } from './observerStamps';
import {
  readSuggestionDecisions,
  useSuggestionDecisionStore,
} from './observerWorkspace/suggestionDecisions';

/**
 * Every live zone and machine refid on every floor's current design: the live twin configuration's
 * entity count and the page's empty-plan check for composite totals read it.
 */
export const liveEntityRefids = (layout: FloorPlannerLayout | null | undefined): string[] =>
  layoutCurrentDesigns(layout ?? null).flatMap(design => [
    ...asArray(design?.surfaces)
      .filter(isLive)
      .map(s => s.refid),
    ...asArray(design?.items)
      .filter(isLive)
      .map(i => i.refid),
  ]);

/**
 * Start the session's records from the plan it opened on. Called beside every wizard
 * `clearModified()`, the one moment a session starts. `null` (a cleared or blank plan) starts with
 * none. What the draft added is not recorded here: Observers reads it from the change source
 * (`onboarding-status-colours-observers`, R2).
 */
export const restoreSessionRecordsFrom = (layout: FloorPlannerLayout | null | undefined): void => {
  /*
   * A session started from a saved plan resumes the records saved with it — the geometry each
   * observer was drawn or confirmed against (`onboarding-polish-observer-notices`, R14). A blank or
   * cleared plan has none, so nothing a reused refid could inherit survives.
   */
  useObserverStampStore.getState().restoreStamps(readObserverReferences(layout));
  // And the Keep mine decisions saved with it (`observer-autogen-review-walkthrough`, R5.3).
  useSuggestionDecisionStore.getState().restore(readSuggestionDecisions(layout));
};
